import React from 'react';
import PropTypes from 'prop-types';

import {
  Button as BsButton,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Button extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.node,
    href: PropTypes.string,
    icon: PropTypes.object,
    iconRight: PropTypes.object,
    label: PropTypes.string,
    outlined: PropTypes.bool,
    plain: PropTypes.bool,
    tooltip: PropTypes.node,
    tooltipProps: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  get buttonVariant() {
    return 'primary';
  }

  render() {
    const {
      children,
      className,
      disabled,
      disabledTooltip,
      href,
      icon,
      label,
      outlined,
      plain,
      tooltip,
      tooltipProps,
      onClick,
      ...props
    } = this.props;

    let variant = this.buttonVariant;
    if (outlined) {
      variant = 'outline';
    } else if (plain) {
      variant = 'ghost';
    }
    props.variant = variant;
    props.className = className;

    const hasDisabledTooltip = disabled && disabledTooltip;
    props.disabled = disabled;
    if (!hasDisabledTooltip) {
      props.onClick = onClick;
    }

    let iconRight = this.props.iconRight;
    delete props.iconRight;

    props['aria-label'] = props['aria-label'] || label;

    let button = (
      <BsButton {...props}>
        {icon && <FontAwesomeIcon icon={icon} />}
        {children || label}
        {iconRight && <FontAwesomeIcon icon={iconRight} />}
      </BsButton>
    );

    if (href) {
      button = <a href={href}>{button}</a>;
    }

    if (hasDisabledTooltip || tooltip) {
      button = (
        <OverlayTrigger
          overlay={
            <Tooltip id="disabled-button-tooltip">
              {hasDisabledTooltip ? disabledTooltip : tooltip}
            </Tooltip>
          }
          placement="bottom"
          {...tooltipProps}
        >
          <span>{button}</span>
        </OverlayTrigger>
      );
    }

    return button;
  }
}
